import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from 'reportWebVitals';
import {
  BrowserRouter,
  Switch,
  Route
} from "react-router-dom";

import 'assets/css/app-normalize.css';
import 'assets/css/app-stylesheet.css';

import ErrorBoundary from 'components/Error/ErrorBoundary';
import ErrorMessage from 'components/Error/ErrorMessage';

import Routes from 'routes/Routes';

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <ErrorBoundary fallback={<ErrorMessage OnClick={() => document.location.reload()} fullPage />}>
        <Route path="*" render={props => <Routes {...props} />} />
      </ErrorBoundary>
    </Switch>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
